export default class ViewerElementResizer {
    constructor(id, resizerId) {
        this._element = document.getElementById(id);
        this._resizer = document.getElementById(resizerId);

        this._resizeHandler = this._resizing.bind(this);
        this._stopResizeHandler = this._stopResize.bind(this);

        this._resizer.addEventListener('mousedown', this._initResize.bind(this));
        this._resizer.addEventListener('touchstart', this._initResize.bind(this));
    }

    /**
    * タブを切り替えます。
    * @param {MouseEvent} event イベント。
    */
    _initResize(event) {
        event.preventDefault();

        window.addEventListener('mousemove', this._resizeHandler, false);
        window.addEventListener('touchmove', this._resizeHandler, false);
        window.addEventListener('mouseup', this._stopResizeHandler, false);
        window.addEventListener('touchend', this._stopResizeHandler, false);
    }

    /**
     * タブを切り替えます。
     * @param {MouseEvent} event イベント。
     */
    _resizing(event) {
        event.preventDefault();

        const e = event.type === "mousemove" ? event : event.changedTouches[0];

        window.document.body.style.cursor = 'ew-resize';
        this._element.style.width = e.clientX - this._element.offsetLeft + 'px';
    }

    /**
     * タブを切り替えます。
     * @param {MouseEvent} event イベント。
     */
    _stopResize(event) {
        window.document.body.style.cursor = '';
        window.removeEventListener('mousemove', this._resizeHandler);
        window.removeEventListener('touchmove', this._resizeHandler);
        window.removeEventListener('mouseup', this._stopResizeHandler);
        window.removeEventListener('touchend', this._stopResizeHandler);
    }
}